export default __webpack_public_path__ + "static/char-s-45-ja-8ec5d9b35d892bae47878bd0ac5c2471.webp";